import React from 'react'
import { useForm } from 'react-hook-form'
import CrudEdit from '~/components/CrudEdit'
import IFirearmCaliber from '../interfaces/IFirearmCaliber'
import Layout from '~/components/Layout'

export default function Edit() {
  const {
    register,
    handleSubmit,
    control,
    setValue: setFormValue,
    getValues,
  } = useForm<IFirearmCaliber>()

  const fields = [
    { name: 'id', type: 'hidden' },
    { name: 'name', type: 'string' },
  ]

  return (
    <Layout marginLayout={true}>
      <CrudEdit
        model={'firearm-caliber'}
        fields={fields}
        register={register}
        handleSubmit={handleSubmit}
        control={control}
        setFormValue={setFormValue}
        messageSuccess={'Firearm caliber successfully updated!'}
        title={'Edit firearm caliber'}
        getValues={getValues}
      />
    </Layout>
  )
}
